<template>
  <div class="main-container">
    <div class="form-verify">
      <div style="display: flex; justify-content: center; margin-bottom: 10px">
        <img alt="Atosa"
             style="width:80px; height:80px; background-color:white; border-radius: 50vh; padding:3px !important;"
             src="/static/img/logo.png"/>
      </div>
      <div style="text-align: center; padding: 0 10px">
        <strong style="text-transform: uppercase; font-size: 18px; color: #125570;">
          {{ $t('base.update_new_password') }}
        </strong>
      </div>
      <div style="margin-top: 30px">
        <form @submit="m__set_password">
          <div style="margin-top: 10px">
            <strong style="font-size: 14px">
              {{ $t('hi') }} {{ display_name }}! {{ $t('base.set_new_pass_for') }} {{ username }}.
            </strong>
          </div>

          <div style="margin-top: 20px">
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.new_password') }}
            </p>
            <el-input v-model="new_password" :placeholder="$t('input.new_password')" type="password"
                      :show-password="true">
            </el-input>
          </div>
          <div style="margin-top: 15px">
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.confirm_password') }}
            </p>
            <el-input v-model="confirm_password" :placeholder="$t('input.confirm_password')" type="password"
                      :show-password="true">
            </el-input>
          </div>

          <div style="margin-top: 25px">
            <el-button type="summit" class="full-w" :loading="loading"
                       @click="m__set_password">
              {{ $t('base.update_password') }}
            </el-button>
          </div>

          <div style="margin-top: 35px; text-align: center">
            <a href="javascript:void(0)" @click="$router.push('/login')">
              <strong style="font-size: 14px" class="text-primary">< {{ $t('base.back_to_login') }}</strong>
            </a>
          </div>

          <button type="submit" style="display: none;"/>
        </form>
      </div>
    </div>

    <div class="info-container">
      <div>
        <strong>{{ $t('base.join_shopee_ads_course') }} </strong>
        <a href="https://www.quangcaoshopee.com" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
      <div>
        <strong> {{ $t('base.learn_about_atosa') }}</strong>
        <a href="https://atosa.asia" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
    </div>

    <el-dialog width="800px" :close-on-click-modal="false" :visible.sync="success_dialog"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="text-align: center; margin-top: 30px">
          <strong style="font-size: 18px; color: tomato">
            {{ $t('base.update_password_success') }}
          </strong>
        </div>
        <div style="text-align: center; margin-top: 10px">
          <strong style="font-size: 14px;">
            {{ $t('base.update_password_success_message') }}
          </strong>
        </div>
        <div style="text-align: center; margin-top: 25px">
          <el-button type="primary" class="summit-button" @click="m__confirm_reset_successfully">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'login-page',

  data() {
    return {
      display_name: 'Bạn',
      username: 'của bạn',
      verify_token: '',
      new_password: '',
      confirm_password: '',
      email: '',
      recaptcha_response: '',
      loading: false,
      success_dialog: false
    }
  },

  // beforeCreate () {
  //   if (typeof this.$store.state.userInfo.username !== 'undefined') this.$router.push('/')
  // },

  async beforeMount() {
    this.verify_token = this.$route.query.token
    try {
      const token_info_resp = await this.$http.get(`https://api.atosa.asia/api/input/sign/forgot-password/get?token=${this.verify_token}`)
      this.display_name = token_info_resp.body.data.display_name
      this.username = token_info_resp.body.data.username
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    m__confirm_reset_successfully() {
      this.success_dialog = false

      if (this.$route.query.redirect_url) {
        window.location.href = this.$route.query.redirect_url
      } else {
        window.location.href = '/'
      }
    },

    async m__reload_recaptcha() {
      this.recaptcha_response = await this.m__get_recaptcha_token()
    },

    m__get_recaptcha_token() {
      return new Promise(resolve => {
        grecaptcha.ready(async () => {
          const token = await grecaptcha.execute('6LeRDzwsAAAAANIpanr9MucIT5UtBADe8uMhXm-S', {action: 'validate_captcha'})
          resolve(token)
        })
      })
    },

    async m__set_password() {
      if (!this.new_password || this.new_password.length < 6) {
        this.ntf_w(this.$t('required.at_least_6_letter'))
        return
      }

      if (this.confirm_password !== this.new_password) {
        this.ntf_w(this.$t('required.not_math_password'))
        return
      }

      await this.m__reload_recaptcha()
      if (!this.recaptcha_response) {
        this.ntf_w(this.$t('required.captcha'))
        return
      }

      this.loading = true
      try {
        await this.$http.post('https://api.atosa.asia/api/input/sign/forgot-password/set', {
          captcha: this.recaptcha_response,
          response: this.recaptcha_response,
          captcha_version: 'v3',
          password: this.new_password,
          token: this.verify_token
        })
        this.success_dialog = true
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading = false
        await this.m__reload_recaptcha()
      }
    }
  }
}
</script>

<style lang="scss">
.main-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url("/static/img/Group 483x3.png");
  //background-position-x: -10px;
  background-position-y: -60px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.form-verify {
  width: 430px;
  position: absolute;
  top: 10%;
  //top: 50%;
  //transform: translate(0, -50%);
  //right: 130px;
  right: 8%;
  padding: 25px 30px;
  margin: auto;

  background: #FFFFFF;
  box-shadow: 0 2px 22px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.info-container {
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 0 0 15px;

  div strong {
    font-size: 13px;
    color: #041722;
    line-height: 30px;
  }

  div a {
    font-size: 13px;
    line-height: 30px;
    font-weight: bold;
  }
}

@media screen and (min-width: 1600px) {
  .form-verify {
    top: 18%;
    right: 13%;
  }
}

@media screen and (min-width: 1900px) {
  .form-verify {
    top: 18%;
    right: 13%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forgot/verify.vue